const Joi = require("joi");
const ValidationTranslateFile = require("../Loc/ValidationTranslateFile.jsx");
const currentLang = ValidationTranslateFile()

const RequestFormInfoSchema = (data) => {

    const schema = Joi.object({
        description: Joi.string()
            .trim()
            .required()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Description_Required,
                "any.required": currentLang?.ValidationSchema?.Description_Required,
            }),

    }).unknown(true);

    return schema.validate(data, {
        abortEarly: false,
    });
};

module.exports = RequestFormInfoSchema;
